import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {PrintPackingSlipResult} from '../types/PrintPackingSlipResult';

export const usePrintPackingSlip = (
	retailOrderID: number,
	onSuccess: (result: PrintPackingSlipResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/print-packing-slip",
				{
					retailOrderID: retailOrderID,
				}) as PrintPackingSlipResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when printing packing slip: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
